import BaseModel from './BaseModel';

class ServiceTypeMap extends BaseModel {
    constructor(data = {}) {
      super(data);
      this.updateData(data);
    }

    updateData = (data) => {
      this.id = data.id;
      this.user_id = data.user_id;
      this.parent_service_type_ids = data.parent_service_type_ids || [];
      this.child_service_type_ids = data.child_service_type_ids || [];
    }

    toApiJson = () => {
      this.completeValidation();
      return {
        service_type_user_mappings: this.child_service_type_ids.map((id) => {
          return {user_id: this.user_id, service_type_id: id}
        }),
      }
    }

    validations = (field) => {
      return {
        parent_service_type_ids: () => {
          if (this[field].length === 0) {
            this.errors.parent_service_type_ids = "Please select parent service type.";
          } else{
            delete this.errors.parent_service_type_ids;
          }
        },
        child_service_type_ids: () => {
          if (this[field].length === 0) {
            this.errors.child_service_type_ids = "Please select child service type.";
          } else{
            delete this.errors.child_service_type_ids;
          }
        },
      }[field];
    }

    validate = (field) => {
      if (this.validations(field)) {
        this.validations(field)()
      }
    }
}

export default ServiceTypeMap;
